import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	repeat: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.repeat',
		defaultMessage: 'Repeat',
		description: 'label for Repeat field',
	},
	eachYear: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.each-year',
		defaultMessage: 'Each year',
		description: 'frequency message for each year dropdown option',
	},
	never: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.never',
		defaultMessage: 'Never',
		description: 'frequency message for never dropdown option',
	},
	frequency: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.frequency',
		defaultMessage: 'Frequency',
		description: 'label for Frequency field',
	},
	annually: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.annually',
		defaultMessage: 'Annually',
		description: 'frequency message for annually dropdown option',
	},
	oneTime: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.one-time',
		defaultMessage: 'One time',
		description: 'frequency message for One time dropdown option',
	},
});
